export const chatKeys = {
  all: ["chat"] as const,
  token: () => [...chatKeys.all, "token"] as const,
}
